import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilmCollectionRewardCard',
  props: {
    containerClass: { default: 'rounded-xl bg-stats-card full-width py-4' },
    upperTitle: { default: '' },
    upperStatsText: { default: '' },
    upperContainerClass: { default: 'd-flex align-center pb-4 px-6 flex-grow-1 justify-space-between' },
    lowerTitle: { default: '' },
    lowerStatsText: { default: '' },
    lowerContainerClass: { default: 'd-flex align-center pt-4 px-6 flex-grow-1 justify-space-between' },
    upperContainerMinWidth: { default: 'auto' },
    lowerContainerMinWidth: { default: 'auto' },
    upperContainerMaxWidth: { default: 'auto' },
    lowerContainerMaxWidth: { default: 'auto' },
    upperContainerWidth: { default: 'auto' },
    lowerContainerWidth: { default: 'auto' },
    containerMinWidth: { default: 'max-content' },
    containerMaxWidth: { default: '360px' },
    containerWidth: { default: '100%' }
  },
  emits: ["lowClick"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'lowClick', event: Event): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { containerClass: string, upperTitle: string, upperStatsText: string, upperContainerClass: string, lowerTitle: string, lowerStatsText: string, lowerContainerClass: string, upperContainerMinWidth: number | string, lowerContainerMinWidth: number | string, upperContainerMaxWidth: number | string, lowerContainerMaxWidth: number | string, upperContainerWidth: number | string, lowerContainerWidth: number | string, containerMinWidth: number | string, containerMaxWidth: number | string, containerWidth: number | string };





const styles = computed(() => {
  const stylesObj: Record<string, any> = {};

  stylesObj['--upper-container-min-width'] =
    typeof props.upperContainerMinWidth === 'string'
      ? props.upperContainerMinWidth
      : typeof props.upperContainerMinWidth === 'number'
      ? `${props.upperContainerMinWidth}px`
      : 'auto';

  stylesObj['--lower-container-min-width'] =
    typeof props.lowerContainerMinWidth === 'string'
      ? props.lowerContainerMinWidth
      : typeof props.lowerContainerMinWidth === 'number'
      ? `${props.lowerContainerMinWidth}px`
      : 'auto';

  stylesObj['--upper-container-max-width'] =
    typeof props.upperContainerMaxWidth === 'string'
      ? props.upperContainerMaxWidth
      : typeof props.upperContainerMaxWidth === 'number'
      ? `${props.upperContainerMaxWidth}px`
      : 'auto';

  stylesObj['--lower-container-max-width'] =
    typeof props.lowerContainerMaxWidth === 'string'
      ? props.lowerContainerMaxWidth
      : typeof props.lowerContainerMaxWidth === 'number'
      ? `${props.lowerContainerMaxWidth}px`
      : 'auto';

  stylesObj['--upper-container-width'] =
    typeof props.upperContainerWidth === 'string'
      ? props.upperContainerWidth
      : typeof props.upperContainerWidth === 'number'
      ? `${props.upperContainerWidth}px`
      : 'auto';

  stylesObj['--lower-container-width'] =
    typeof props.lowerContainerWidth === 'string'
      ? props.lowerContainerWidth
      : typeof props.lowerContainerWidth === 'number'
      ? `${props.lowerContainerWidth}px`
      : 'auto';

  stylesObj['--container-min-width'] =
    typeof props.containerMinWidth === 'string'
      ? props.containerMinWidth
      : typeof props.containerMinWidth === 'number'
      ? `${props.containerMinWidth}px`
      : 'auto';

  stylesObj['--container-max-width'] =
    typeof props.containerMaxWidth === 'string'
      ? props.containerMaxWidth
      : typeof props.containerMaxWidth === 'number'
      ? `${props.containerMaxWidth}px`
      : 'auto';

  stylesObj['--container-width'] =
    typeof props.containerWidth === 'string'
      ? props.containerWidth
      : typeof props.containerWidth === 'number'
      ? `${props.containerWidth}px`
      : 'auto';

  return stylesObj;
});

return { __sfc: true,emit, props, styles }
}

})